<template>
  <div class="page">
 <div class="group_1">
  <div>

本《课程资源库平台会员服务协议》（以下简称 “本协议”）由用户（以下简称 “您”）与【平台运营方名称】（以下简称 “平台”）共同订立。请您在开通会员服务前，仔细阅读本协议全部内容。您点击确认或实际使用会员服务，即视为您已充分理解并同意本协议全部条款，本协议对双方具有法律约束力。
<br>
一、定义<br>

1.课程资源库平台：指由平台运营的，为用户提供各类课程资料学习服务的网络平台，包括但不限于网页端、移动端应用程序等。<br>

2.会员服务：指平台为会员用户提供的，在会员有效期内，可免费学习观看平台内指定课程资源的增值服务。<br>

3.会员有效期：指您成功开通会员服务后，享有会员权益的期限，具体时长以您开通会员时选择的套餐为准。<br>

二、会员服务内容<br>

在会员有效期内，您可免费学习观看平台内标注为会员专享的全部课程资料。<br>

三、会员开通与费用<br>

1.开通方式：您可通过平台提供的支付渠道，如微信支付、支付宝等，选择相应的会员套餐进行开通。会员服务自您成功支付费用并开通之时起生效。<br>

2.费用标准：平台不同会员套餐的费用标准以平台公示信息为准。平台保留根据市场情况调整会员费用标准的权利，若费用发生变更，将在平台显著位置进行公示。如您在费用变更后继续使用会员服务，视为您同意新的费用标准。<br>

3.费用支付与发票开具：您应按照平台规定的支付方式及时支付会员费用。如需开具发票，您可在支付成功后，通过平台指定的方式申请开具发票，平台将在符合相关法律法规和财务规定的前提下，为您提供发票开具服务。<br>

四、双方权利与义务<br>

（一）平台权利与义务<br>

1.权利：<br>

◦有权根据法律法规、政策变化、平台运营需要，对本协议内容、会员服务内容及规则进行修订和调整，并在平台显著位置进行公示。若您不同意修订后的协议内容，可停止使用会员服务；若您继续使用会员服务，视为您接受修订后的协议内容。<br>

◦有权对您使用会员服务的行为进行监督和管理，若发现您存在违反本协议约定或其他违法违规行为，有权采取限制或终止会员服务、删除违规内容等措施。<br>

1.义务：<br>

◦按照本协议约定，为您提供稳定、优质的会员服务，保障平台内课程资源的正常更新和维护。<br>

◦采取必要的技术措施和管理措施，保护您的个人信息和数据安全，不得泄露、篡改或毁损您的个人信息，但法律法规另有规定或经您同意的除外。<br>

◦及时处理您在使用会员服务过程中遇到的问题和反馈，为您提供必要的技术支持和服务保障。<br>

（二）您的权利与义务<br>

1.权利：<br>

◦在会员有效期内，享有本协议约定的会员服务权益，有权对平台提供的会员服务提出意见和建议。<br>

◦有权要求平台保护您的个人信息和数据安全，对平台违反个人信息保护相关规定的行为，有权向相关部门投诉或举报。<br>

1.义务：<br>

◦遵守本协议约定及平台发布的各项规则，不得利用会员服务从事任何违法违规活动，包括但不限于传播淫秽、暴力、恐怖、虚假信息，侵犯他人知识产权、隐私权等合法权益。<br>

◦妥善保管您的账号和密码，因您自身原因导致账号和密码泄露或被他人使用而造成的损失，由您自行承担。不得将您的会员账号转借、出租、出售或与他人共享。<br>

◦尊重平台及其他用户的知识产权和合法权益，不得擅自复制、传播、修改平台内的课程资源，不得利用平台内的课程资源进行商业用途或其他营利活动。<br>

五、会员服务的变更、终止与退款<br>

1.服务变更：因不可抗力、技术故障、法律法规变化等原因，平台可能无法按照约定提供全部或部分会员服务，或需要对会员服务内容进行变更。在此情况下，平台将及时通知您，并采取合理措施减少对您的影响。<br>

2.服务终止：<br>

◦若您违反本协议约定或平台相关规则，平台有权单方面终止您的会员服务，且不退还已收取的会员费用。<br>

◦若平台因自身原因需要终止会员服务，将提前通知您，并按照剩余会员有效期对应的费用比例，向您退还相应的会员费用。<br>

1.退款政策：除本协议另有约定外，会员服务一经开通，不支持无理由退款。如因平台原因导致您无法正常使用会员服务，或符合法律法规规定的退款情形，平台将按照相关规定为您办理退款。<br>

六、违约责任<br>

1.若一方违反本协议约定，应向对方承担违约责任，赔偿对方因此遭受的全部损失，包括但不限于直接损失、间接损失、律师费、诉讼费等。<br>

2.您违反本协议约定，利用会员服务从事违法违规活动或侵犯他人合法权益的，除承担相应的违约责任外，还应自行承担由此产生的一切法律后果。平台有权配合相关部门进行调查处理，并有权要求您赔偿因此给平台造成的损失。<br>

七、争议解决<br>

本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。双方在履行本协议过程中发生的争议，应首先通过友好协商解决；协商不成的，任何一方均有权向平台所在地有管辖权的人民法院提起诉讼。<br>

八、其他条款<br>

1.本协议构成双方就会员服务相关事宜达成的全部协议，取代双方之前就该事项达成的所有口头或书面协议。<br>

2.本协议部分条款被认定为无效或不可执行的，不影响其他条款的效力和执行。<br>

3.平台在本协议中未行使或延迟行使任何权利或救济措施，不构成对该权利或救济措施的放弃；平台对您的任何违约行为给予任何宽限或延缓，不视为对您后续违约行为的豁免。<br>

【安徽冠成教育科技有限公司】<br>

日期：[2025.06.16]</div>
</div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';


export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
    
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
 
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #fff;
  // height: 100%;
  overflow-y: scroll;
}

.group_1{
  padding: 10px 15px;
}
.text_1{
  text-align: center;
  margin-bottom: 10px;
}
</style>
